module.exports = __webpack_public_path__ + "static/media/traumaActive.72da0fde.svg";